<template>
  <modal
    name="managesend-validation-modal"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="650"
    height="auto"
    @closed="closeModal()"
  >
    <div class="modalWrapper">
      <div class="content__box">
        <div class="content__box__header">
          <div class="row">
            <div class="col-6">
              <p class="text-white txt--ss opacity--50">Manage Validations</p>
            </div>
            <div class="col-6">
              <p class="text-white txt--ss opacity--50 text-right">
                <span class="cursor-pointer" @click="openModal(childModalName)"
                  >Send Validations</span
                >
              </p>
            </div>
          </div>
        </div>
        <div class="content__divider"></div>

        <div class="content__box__body content__box__body__audit__table">
          <!-- <div class="table-responsive"> -->
           <!--  <div class="content__box__body"> -->

              <div class="">

                <div class="row mb-2">
                  <div class="col-5">
                    <p class="txt--primary txt--xs txt--semi-bold">
                      Department <i class="ml-1 fas fa-angle-down"></i>
                    </p>
                  </div>
                  <div class="col-4">
                    <p class="txt--xs txt--semi-bold opacity--50">
                      Validations remaining
                    </p>
                  </div>
                </div>

                <div v-for="(department, index) in departments_list" :key="index">
                  <div class="row mb-2" v-if="department.validation_total_quantity >0">
                    <div class="col-5">
                      <p class="txt--primary property__header__text cursor-pointer">
                        {{department.department_name}}
                      </p>
                    </div>
                    <div class="col-4">
                      <p class="txt--primary property__header__text cursor-pointer" 
                      :title="`Net Used : ${department.validation_total_used_without_unused_quantity},
Unused : ${department.validation_total_unused_quantity}`"       
                    >
                        {{department.validation_total_remaining_quantity}}
                        /                   
                        {{department.validation_total_quantity}}
                      </p>
                    </div>
                  </div>
                  <div class="row mb-2" v-for="(validation_detail, index) in department.validation_details" :key="index">
                    <div class="col-5">
                      <p class="text-white txt--ss pl-3">{{validation_detail.validation_name}}</p>
                    </div>
                    <div class="col-4">
                      <p class="text-white txt--ss cursor-pointer" title="Remaining Validation">
                        {{validation_detail.reamining_quantity }}
                        /
                        {{validation_detail.quantity }}              
                      </p>
                    </div>
                    <div class="col-3">
                      <p class="text-white txt--ss opacity--50">
                        <span class="cursor-pointer" @click="removeValidations(department, validation_detail)"
                          >Remove</span
                        >
                      </p>
                    </div>
                  </div>
                </div>
                
              </div>

              <infinite-loading
                    @infinite="getValidationName"
                    :distance="10"
                    force-use-infinite-wrapper=".content__box__body.content__box__body__audit__table"
                    v-if="departments_list !== null && departments_list.length > 0 && manageValidationPagination.load_more"
                    :identifier="manageValidation_infiniteId"
                  >
                    <div slot="spinner">
                      <div class="d-flex justify-content-center mt-4">
                        <div class="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                    <div slot="no-more"></div>
                    <div slot="no-results">No data found</div>
              </infinite-loading>

           <!--  </div> -->
         <!--  </div> -->
        </div>

      </div>

      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
    <SendValidation @update_validation_management_list="refreshList"/>
  </modal>
</template>
<script>
import "vue-search-select/dist/VueSearchSelect.css";
import SendValidation from "../../components/modals/SendValidation";
import Toggle from "@/components/toggle";
import axios from "../../axios";
export default {
  name: "ManageSendValidation",
  components: {
    SendValidation,
  },
  props: ["childModalName"],
  data() {
    return {
      value: null,
      unlimited_validaiton: true,
      departments_list: [],
      manageValidationPagination: {
        to:         0,
        page:       1,
        total:      0,
        load_more:  true,
        infiniteId: +new Date(),
      },
      manageValidation_infiniteId: +new Date(),
    };
  },

  created() {
    this.getValidationName();
  },
  methods: {
    removeValidations(department, validationDetail) {
      this.$swal({
        title: "",
        text: `Enter the number of validations you want to remove for ${validationDetail.validation_name}`,
        input: "number",
        inputAttributes: {
          placeholder: "Quantity"
        },
        showCancelButton: true,
      }).then((result) => {
        if (result.value > 0) {
          this.axios
            .post(window.hostname + "/api/auth/validation/remove_validation", {
              validation_id: validationDetail.validation_id,
              department_id: department.department_id,
              quantity: result.value,
            })
            .then((res) => {
              this.refreshList();
              this.$toasted.show('Validation saved successfully!', {
                icon: "check-circle",
                className: "success-class",
              });
            })
            .catch((err) => {
              this.$toasted.show('Something went wrong. Please try again !', {
                icon : 'times-circle',
                className: "error-class",
              });
            });
        }
      });
    },
    closeModal() {
      this.$modal.hide("managesend-validation-modal");
    },
    openModal(modalName) {
      this.$modal.show(modalName);
    },
    refreshList(){
      //alert();     
      this.manageValidationPagination.page = 1;     
      this.manageValidationPagination.load_more = false;
      this.departments_list =[];
      this.unlimited_validaiton = true;
      this.getValidationName();
    },
    getValidationName()
    {
      axios
        // .post(window.hostname + "api/auth/validation/getDepartments", 
        .post(window.hostname + "api/auth/validation/get-manage-validation", 
        {
          page: this.manageValidationPagination.page,
         // limit:2,
          device_type:  1,
          all:1,
        })
        .then(res => {
          if (res.data.status && Object.keys( res.data.departments_list).length > 0 )
          {
            let department_Lists =  res.data.departments_list;
            department_Lists.map((val) => {
              this.departments_list.push(val);
            });

            this.manageValidationPagination.to        = res.data.pagination.to;
            this.manageValidationPagination.page      = res.data.pagination.page;
            this.manageValidationPagination.total     = res.data.pagination.total;
            this.manageValidationPagination.load_more = res.data.pagination.load_more == 1 ? true : false;
            this.manageValidation_infiniteId++;
          }
          else
          {
            this.departments_list = [];
            this.manageValidationPagination.to = 0;
            this.manageValidationPagination.page = 1;
            this.manageValidationPagination.total = 0;
            this.manageValidationPagination.load_more = false;
          }
        })
        .catch(res => {

        })
    },
  },
};
</script>

<style scoped>
.modified-toggle-switch p {
  flex-basis: 50%;
}

.modified-toggle-switch app-toggle {
  flex-basis: 50%;
}
input[type="text"] {
  background: transparent;
  outline: none;
  border-radius: 22px;
  border: 1px solid #535353;
}
.quantity {
  color: #848484;
  font-size: 10px;
}
</style>